import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

type Props = {
  lastSyncInfo: { timestamp: number; updatedBy: string } | null;
};

export const FinanceDisclaimer = ({ lastSyncInfo }: Props) => {
  const { translations } = useLanguage();
  const [showDisclaimer, setShowDisclaimer] = useState(true);

  if (!showDisclaimer) return null;

  // Format date helper function
  const formatDate = (timestamp: number): string => {
    return new Date(timestamp).toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 relative"
    >
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          <AlertTriangle className="h-6 w-6 text-yellow-500" />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <span className="text-yellow-800 font-semibold">
              {translations?.organizerFinance?.importantNotice || 'Important Notice'}
            </span>
           
          </div>
          <p className="mt-1 text-yellow-700">
            {translations?.organizerFinance?.disclaimerText || 'All amounts and payments displayed are subject to change without any legal liability or prior notice. This statement is not final and does not represent a financial obligation by ithraa Al-Khair.'}
          </p>
        </div>
        <button
          onClick={() => setShowDisclaimer(false)}
          className="text-yellow-500 hover:text-yellow-700 transition-colors"
        >
          <span className="sr-only">Close</span>
          <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </button>
      </div>
    </motion.div>
  );
};